import { ErrorCode } from "./types"

type Matcher = {
    pattern: RegExp | string
    code: ErrorCode
}

const MATCHERS: Matcher[] = [
    { pattern: /password.*too short/i, code: ErrorCode.PASSWORD_TOO_SHORT },
    { pattern: /password.*short/i, code: ErrorCode.PASSWORD_TOO_SHORT },
    { pattern: /password.*mismatch/i, code: ErrorCode.PASSWORD_MISMATCH },
    { pattern: /passwords.*match/i, code: ErrorCode.PASSWORD_MISMATCH },
    { pattern: /password.*weak/i, code: ErrorCode.PASSWORD_WEAK },
    { pattern: /invalid.*email/i, code: ErrorCode.EMAIL_INVALID },
    { pattern: /email.*invalid/i, code: ErrorCode.EMAIL_INVALID },
    { pattern: /email.*exists/i, code: ErrorCode.EMAIL_ALREADY_EXISTS },
    { pattern: /already.*registered/i, code: ErrorCode.EMAIL_ALREADY_EXISTS },
    { pattern: /invalid.*credentials/i, code: ErrorCode.INVALID_CREDENTIALS },
    { pattern: /incorrect.*password/i, code: ErrorCode.INVALID_CREDENTIALS },
    { pattern: /user.*not.*found/i, code: ErrorCode.USER_NOT_FOUND },
    { pattern: /no.*account/i, code: ErrorCode.USER_NOT_FOUND },
    { pattern: /network.*error/i, code: ErrorCode.NETWORK_ERROR },
    { pattern: /fetch.*failed/i, code: ErrorCode.NETWORK_ERROR },
    { pattern: /rate.*limit/i, code: ErrorCode.RATE_LIMITED },
    { pattern: /too.*many.*requests/i, code: ErrorCode.RATE_LIMITED },
    { pattern: /required/i, code: ErrorCode.REQUIRED_FIELD },
]

export function matchErrorString(rawError: string): ErrorCode {
    const normalized = rawError.toLowerCase().trim()

    for (const matcher of MATCHERS) {
        const matches =
            typeof matcher.pattern === "string"
                ? normalized.includes(matcher.pattern.toLowerCase())
                : matcher.pattern.test(normalized)

        if (matches) {
            return matcher.code
        }
    }

    return ErrorCode.UNKNOWN
}
